<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
  },
  components: {
    Label,
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  data() {
    return {
      value: this.item_value,
      categoryName: this.$route.params.categoryName,
    };
  },
  watch: {
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
  },
};
</script>
<template>
  <div class="mb-3">
    <Label :item="item" />
    <div class="flex col-12 mt-2">
      <div
        v-for="option in item.options"
        v-bind:key="option.name"
        class="form-check col-4"
      >
        <input
          class="form-check-input"
          type="radio"
          v-model="value"
          v-bind:value="option"
          :disabled="
            categoryName == 'globalupdate'
              ? false
              : selectedItem.additionalProp1.global
              ? true
              : false
          "
        />
        <label class="form-check-label ml-2">{{ option.name }}</label>
      </div>
    </div>

    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
<style scoped>
.form-check-input {
  transform: scale(1.8);
  cursor: pointer;
  accent-color: #005eb8 !important;
}
</style>
